export var getIncrementalGeneratedId = (function () {
    var number = 1;
    return function () {
        return number++;
    };
})();
